// Reveals `.fdd-reveal` elements as they scroll into view. Loaded as a module, so the
// browser evaluates it once however many homepage sections reference it.

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      )
    : null;

function reveal(root = document) {
  const elements = root.querySelectorAll('.fdd-reveal:not([data-fdd-observed])');

  elements.forEach((element, index) => {
    element.dataset.fddObserved = 'true';

    // No observer, or the visitor asked for less motion: show it straight away.
    if (!observer || REDUCED_MOTION.matches) {
      element.classList.add('is-visible');
      return;
    }

    element.style.transitionDelay = `${(index % 3) * 80}ms`;
    observer.observe(element);
  });
}

reveal();

// Sections are re-rendered as the merchant edits them in the theme editor.
document.addEventListener('shopify:section:load', (event) => reveal(event.target));
